import { useAppSelector } from '@/common/reducers/hooks/store.hook';
import { Box, Typography } from '@mui/material';
import { makeSelectMessageDraftById } from '@/components/team-inbox/redux/TeamInboxSelectors';
import { UserMessage } from '@bt-common/schemas/bt/user-message';


export default function AddScheduledMessageLinkPreview({ messageId, messageOverride }: { messageId?: string; messageOverride?: Partial<UserMessage> }) {
    // Use messageDraft for real-time preview updates (avoids race conditions with wrapper)
    const reduxDraft = useAppSelector(state => makeSelectMessageDraftById(messageId ?? null)(state));
    const messageDraft = messageOverride ?? reduxDraft;

    return (
        <>
            {(messageDraft?.linkPreview && messageDraft?.linkPreview?.thumbnail) &&
                <Box
                    sx={{
                        mt: 1,
                        borderRadius: '6px',
                        overflow: 'hidden',
                        bgcolor: 'var(--tasks-picker-bg)',
                        border: '1px solid var(--tasks-cell-border)',
                        width: '100%'
                    }}
                >
                    {messageDraft?.linkPreview?.thumbnail && (
                        <Box sx={{ width: '100%', height: '160px', overflow: 'hidden' }}>
                            <img
                                src={messageDraft?.linkPreview?.thumbnail}
                                alt="Link preview"
                                style={{
                                    color: 'var(--color-primary)',
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    display: 'block'
                                }}
                            />
                        </Box>
                    )}
                    <Box sx={{ p: 1.5 }}>
                        <Typography
                            dir="auto"
                            sx={{
                                color: 'var(--color-primary)',
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                mb: 0.5,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {messageDraft?.linkPreview?.title || messageDraft?.linkPreview?.matchedText}
                        </Typography>
                        {messageDraft?.linkPreview?.description && (
                            <Typography
                                dir="auto"
                                sx={{
                                    color: 'var(--tasks-text-secondary)',
                                    fontSize: '0.75rem',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    wordBreak: 'break-word'
                                }}
                            >
                                {messageDraft?.linkPreview?.description}
                            </Typography>
                        )}
                        <Typography
                            dir="auto"
                            sx={{
                                color: '#013750',
                                fontSize: '0.75rem',
                                mt: 0.5,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {messageDraft?.linkPreview?.matchedText && new URL(messageDraft?.linkPreview?.matchedText).hostname}
                        </Typography>
                    </Box>
                </Box>
            }
        </>
    );
}